import React, { useState } from "react";
import rewardimage from "../../../assets/reward.png";
import { RxCross1 } from "react-icons/rx";
function RewardPopup() {
  const [isVisible, setIsVisible] = useState(true);

  const handleClaim = () => {
    // alert("Reward Claimed!");
    setIsVisible(false);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg md:w-[531px] md:h-[441.63px] w-[409px] h-[340.16px] p-6 text-center relative">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 text-white hover:text-red-700 rounded-full sm:w-[21.8px] sm:h-[21.8px] w-[21.8px] h-[21.8px] md:w-[28.3px] md:h-[26.81px] flex items-center justify-center font-bold bg-[#AF313D]"
        >
          <RxCross1 />
        </button>

        {/* Gift Icon */}
        <div className="flex justify-center mb-4">
          <img
            src={rewardimage}
            alt="Gift"
            className="md:w-[183.95px] md:h-[201.08px] w-[141.69px] h-[154.88px] sm:w-[141.69px] sm:h-[154.88px] "
          />
        </div>

        {/* Reward Title */}
        <h3 className="text-[#282A37] md:text-[29.79px] font-semibold mb-2">
          Todays Reward
        </h3>

        {/* Reward Amount */}
        <p className="text-[000000] md:text-[34.26px] font-bold mb-6">£100</p>

        {/* Claim Button */}
        <button
          onClick={handleClaim}
          className="bg-[#AF313D] text-white font-semibold py-2 px-6  hover:bg-red-600 w-[361.2px] h-[45px] rounded-md"
        >
          Claim Now
        </button>
      </div>
    </div>
  );
}

export default RewardPopup;
